module.exports = __webpack_public_path__ + "static/media/17230025-5mi1wSgs.24e1c86c.JPG";